module.exports = __webpack_public_path__ + "static/humanitarian_card_img1@2x-ec3eae0d362f19fddc710008024d3798.jpg";